<template>
	<section class="login" style="height:100vh;display:inline-block">
		<div class="login-nav" style="width: 100%;margin: 0 auto;margin-top: 50px!important;">
			<router-link to="/">
				<div class="img-box login" style="display: flex;align-items: center;justify-content: center;">
					<img style="width: 200px !important;" src="../assets/images/Web-logo.png" alt="An image of our logo. Clicking on will redirect you to the home page.">
				</div>
			</router-link>	
		</div>
		<div class="wrapper">
			<form @submit.prevent class="login-form" v-if="formType === 'login'">
				<h2 class="subheading">Please login to place an order.</h2>
				<h3 class="primary-copy">Don't have an account? <button class="toggle-form" @click="toggleForm('signup')">Sign Up</button> or <button class="toggle-form" @click="toggleForm('guest')">Login as guest.</button></h3>
				<label class="tertiary-heading" for="user">Email:</label>
				<input class="primary-copy" type="email" id="user" v-model="loginData.user">
				<label class="tertiary-heading" for="password">Password:</label>
				<input class="primary-copy" type="password" id="password" v-model="loginData.password">
				<input type="button" value="Login" @click="handleLogin">
			</form>
			<form @submit.prevent class="signup-form" v-if="formType === 'signup'">
				<h2 class="subheading">Sign Up</h2>
				<!-- <h3 class="primary-copy">Already have an account? <button class="toggle-form" @click="toggleForm('login')">Login</button> or <button class="toggle-form" @click="toggleForm('guest')">Login as guest.</button></h3> -->
				<div class="signup-form-content">
					<div class="form-left">
						<label for="newEmail" class="tertiary-heading">Email:</label>
						<input class="primary-copy" type="email" id="newEmail" v-model="signupData.email">
						<label for="newFirstName" class="tertiary-heading">First Name:</label>
						<input class="primary-copy" type="text" id="newFirstName" v-model="signupData.firstName">
						<label for="newLastName" class="tertiary-heading">Last Name:</label>
						<input class="primary-copy" type="text" id="newLastName" v-model="signupData.lastName">
						<label for="newPhone" class="tertiary-heading">Phone Number:</label>
						<input class="primary-copy" type="text" id="newPhone" v-model="signupData.phone">
					</div>
					<div class="form-right">
						<label for="newAddress" class="tertiary-heading">Address:</label>
						<input class="primary-copy" type="text" id="newAddress" v-model="signupData.address">
						<label for="newPostalCode" class="tertiary-heading">Postal Code:</label>
						<input class="primary-copy" type="text" id="newPostalCode" v-model="signupData.postalCode">
						<label for="newPassword" class="tertiary-heading">Password:</label>
						<input class="primary-copy" type="password" id="newPassword" v-model="signupData.password">
						<label for="confirmNewPassword" class="tertiary-heading">Confirm Password:</label>
						<input class="primary-copy" type="password" id="confirmNewPassword" v-model="signupData.confirmPassword">
					</div>
				</div>
				<input type="button" value="Sign Up" @click="handleSignup">
			</form>
			<form @submit.prevent class="guest-form" 
			style="
			display: table;
			width: 300px;
			min-width: 0px;
			border: 2px solid #223446;
			padding: 35px;
			border-radius: 5px;"
			
			v-if="formType === 'guest'">
				<!-- <h2 class="subheading">Sign in as Guest</h2> -->
				<!-- <h3 class="primary-copy">Already have an account? <button class="toggle-form" @click="toggleForm('login')">Login</button> or <button class="toggle-form" @click="toggleForm('signup')">Sign Up</button> to make ordering faster next time.</h3> -->
				<div style="width:50%;padding-right:20px;float:left;display:inline-block">
					<!-- <label for="guestFirstName" class="tertiary-heading">First Name:</label> -->
					<input placeholder="First Name" type="text" id="guestFirstName" class="primary-copy" v-model="guestData.firstName">
				</div>
				<div style="width:50%;float:left;display:inline-block">
					<!-- <label for="guestLastName" class="tertiary-heading">Last Name:</label> -->
					<input placeholder="Last Name" type="text" id="guestLastName" class="primary-copy" v-model="guestData.lastName">
				</div>
				
				<!-- <label for="guestEmail" class="tertiary-heading">Email:</label> -->
				<input placeholder="Email"  type="email" id="guestEmail" class="primary-copy" v-model="guestData.email">
				<!-- <label for="guestPhone" class="tertiary-heading">Phone:</label> -->
				<input placeholder="Phone Number"  type="text" id="guestPhone" class="primary-copy" v-model="guestData.phone">
				<input type="button" style="width: auto!important;float:right;margin-top:20px;border-radius:2px;background-color:#D00016;color:white;padding:5px" value="Login" @click="handleGuest">
			</form>
			<transition name="fade">
				<div class="errorModal" v-if="error" @click="closeError">
					<div class="errorModal-content">
						<h1 class="heading">Login Failed.</h1>
						<h3 class="primary-copy">{{ errorMessage }}</h3>
					</div>
				</div>
			</transition>
		</div>
	</section>
</template>

<script>
	import $ from 'jquery'
	import Users from '@/controllers/Users'
	import MyNav from './MyNav'

	export default {
		name: 'Login',
		components: {
			MyNav
		},
		data () {
			return {
				formType: 'guest',
				loginData: {
					user: '',
					password: ''
				},
				signupData: {
					email: '',
					firstName: '',
					lastName: '',
					phone: '',
					address: '',
					postalCode: '',
					password: '',
					confirmPassword: ''
				},
				guestData: {
					firstName: '',
					lastName: '',
					email: '',
					phone: ''
				},
				error: false,
				errorTitle: '',
				errorMessage: ''
			}
		},
		methods: {
			toggleForm (nextForm) {
				this.formType = nextForm
			},
			handleLogin () {
				if (this.loginData.user && this.loginData.password) {
					this.login(this.loginData)
				} else {
					this.error = !this.error
					this.errorTitle = 'Login Failed.'
					this.errorMessage = 'Both email and password are required.'
				}
			},
			login (obj) {
				Users.login(obj).then(response => {
					this.$root.loggedIn = true
					this.$root.userData = response.payload
					this.$root.brandId = response.payload.application.brand_id
					this.$router.push({ name: 'Order', params: {cartOpenedRemotely: true} })
				}).catch(reason => {
					console.log(reason)
				})
			},
			handleSignup () {
				let title = 'Signup Failed.'
				if (!this.signupData.email) {
					$('#newEmail').addClass('missing')
					this.error = !this.error
					this.errorTitle = title
					this.errorMessage = 'Email is required'
				} else if (!this.signupData.firstName) {
					$('#newFirstName').addClass('missing')
					this.error = !this.error
					this.errorTitle = title
					this.errorMessage = 'First name is required'
				} else if (!this.signupData.lastName) {
					$('#newLastName').addClass('missing')
					this.error = !this.error
					this.errorTitle = title
					this.errorMessage = 'Last name is required'
				} else if (!this.signupData.address) {
					$('#newAddress').addClass('missing')
					this.error = !this.error
					this.errorTitle = title
					this.errorMessage = 'Address is required'
				} else if (!this.signupData.postalCode) {
					$('#newPostalCode').addClass('missing')
					this.error = !this.error
					this.errorTitle = title
					this.errorMessage = 'Postal code is required'
				} else if (!this.signupData.password) {
					$('#newPassword').addClass('missing')
					this.error = !this.error
					this.errorTitle = title
					this.errorMessage = 'Password is required'
				} else if (!this.signupData.confirmPassword) {
					$('#confirmNewPassword').addClass('missing')
					this.error = !this.error
					this.errorTitle = title
					this.errorMessage = 'Password confirmation is required'
				} else if (this.signupData.password !== this.signupData.confirmPassword) {
					$('#newPassword, #confirmNewPassword').addClass('missing')
					this.error = !this.error
					this.errorTitle = title
					this.errorMessage = 'Password and password confirmation must match.'
				} else {
					this.signup(this.signupData)
				}
			},
			handleGuest () {
				this.errorTitle = 'Guest signup failed.'
				this.errorMessage = 'All fields required.'
				if (!this.guestData.firstName) {
					$('#guestFirstName').addClass('missing')
					this.error = !this.error
				} else if (!this.guestData.lastName) {
					$('#guestLastName').addClass('missing')
					this.error = !this.error
				} else if (!this.guestData.email) {
					$('#guestEmail').addClass('missing')
					this.error = !this.error
				} else if (!this.guestData.phone) {
					$('#guestPhone').addClass('missing')
					this.error = !this.error
				} else {
					this.guestSignup(this.guestData)
				}
			},
			guestSignup (guestInfo) {
				this.$root.loggedIn = true
				this.$root.guest = true
				this.$root.guestData = guestInfo
				this.$root.guestData.phone = parseInt(guestInfo.phone)
				this.$router.push({name: 'ConfirmOrder'})
			},
			closeError () {
				this.error = !this.error
			}
		}
	}
</script>

<style lang='scss' scoped>
	@import '../assets/css/main';
	.wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.login {
		position: relative;
		display: flex;
		width: 100%;
		padding-top: 0;
		overflow: none;
	}

	.errorModal {
		display: flex;
		justify-content: center;
		align-items: center;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5));
		.errorModal-content {
			background: white;
			padding: 10%;
		}
	}

	.login-form, .signup-form, .guest-form {
		width: 100%;
		min-width: 750px;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		@media (max-width: 750px) {
			min-width: 0;
		}
		.tertiary-heading {
			font-size: 2.4rem;
			width: 100%;
			text-align: left;
		}
		input {
			width: 100%;
			margin-bottom: 5%;
		}
		input[type="button"] {
			@include secondary-button;
			width: 25%;
		}
		.toggle-form {
			color: $primary-color;
			cursor: pointer;
			font-weight: 700;	
		}
		input.missing {
			border: 1px solid $primary-color;
		}
	}

	.guest-form {
		input[type='button'] {
			width: 35%;
			transform: translateX(0);
		}
	}

	.signup-form {
		justify-content: center;
		align-items: space-between;
		flex-wrap: wrap;
		.subheading {
			width: 100%;
		}
		.signup-form-content {
			width: 100%;
			display: flex;
			justify-content: space-between;
		}
		.form-left, .form-right {
			width: 45%;
			display: flex;
			flex-direction: column;
		}
	}

</style>


// WEBPACK FOOTER //
// src/components/Login.vue